export class PointMeter {
  meter_number: number;
  meter_type_name: string;
  meter_install_date: Date;
  meter_next_verify_date: Date;
  prec: number;
  phase_number: number;
  user_date: Date;
  user_indications: number;
  org_date: Date;
  org_indications: number;
  sum_consumption: number;
  user_action_name___ru: string;
  user_action_name___kz: string;
  org_action_name___ru: string;
  org_action_name___kz: string;
}
